/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');
var cleanUpResponse = require('common/util/cleanUpResponse');
var _ = require('underscore');
var addressToString = require('common/util/addressToString');

module.exports = function(eventId) {
  var defer = $.Deferred();

  $.soap({
    body: {
      GetEvent: {
        $xmlns: 'http://dobs.pa.gov/co/event/bpm/1.0',
        EventID: eventId
      }
    },
    blueprintArrays: [
      'GetEventResponse.Event',
      'GetEventResponse.EventPresenters.CO_EventPresenter',
      'GetEventResponse.EventDocuments.CO_EventDocument'
    ],
    blueprint: {
      id: '$..EventID',
      eventTypeId: '$..EventTypeID',
      eventTitle: '$..Title',
      eventDescription: '$..Description',
      startDateTime: '$..StartDateTime',
      endDateTime: '$..EndDateTime',
      program1Id: '$..Program1',
      isRegistrationRequired: '$..IsRegRequired',
      numberOfPresentations: '$..NumberOfPresentations',
      registrationDetails: '$..RegDetails',
      targetAudienceId: '$..TargetAudienceID',
      isAARPEvent: '$..IsThirdPartyEvent',
      aarpVolunteers: '$..ThirdPartyVolunteerID',
      eventNotes: '$..EventNotes',
      whoPromoted: '$..WhoPromoted',
      howPromoted: '$..HowPromoted',
      attendance: '$..Attendance',
      eventFormatId: '$..EventFormatID',
      csFolderId: '$..CSFolderID',
      venue: {
        id: '$..VenueID',
        name: '$..VenueName',
        website: '$..VenueWebsite',
        streetAddress: '$..VenueStreetAddress',
        streetAddress2: '$..VenueStreetAddress2',
        city: '$..VenueCity',
        state: '$..VenueState',
        zipCode: '$..VenueZipCode',
        contactId: '$..VenueContactID',
        contactFirstName: '$..VenueContactFirstName',
        contactLastName: '$..VenueContactLastName',
        contactEmail: '$..VenueContactEmail',
        contactPhone: '$..VenueContactPhone'
      },
      organization: {
        id: '$..OrganizationID',
        name: '$..OrganizationName',
        website: '$..OrganizationWebsite',
        streetAddress: '$..OrganizationStreetAddress',
        streetAddress2: '$..OrganizationStreetAddress2',
        city: '$..OrganizationCity',
        state: '$..OrganizationState',
        zipCode: '$..OrganizationZipCode',
        contactId: '$..OrganizationContactID',
        contactFirstName: '$..OrganizationContactFirstName',
        contactLastName: '$..OrganizationContactLastName',
        contactEmail: '$..OrganizationContactEmail',
        contactPhone: '$..OrganizationContactPhone',
        type: '$..OrganizationType',
        typeId: '$..OrganizationTypeID'
      },
      eventPresenters: [
        '$..CO_EventPresenter',
        {
          eventPresenterId: '$.EventPresenterID',
          userId: '$.UserID',
          username: '$.UserName',
          firstName: '$.FirstName',
          lastName: '$.LastName',
          email: '$.Email',
          isTaskOwner: '$.IsTaskOwner'
        }
      ],
      eventDocuments: [
        '$..CO_EventDocument',
        {
          id: '$..ID',
          eventId: '$..EventID',
          documentId: '$..DocumentID',
          message: '$..Message',
          documentName: '$..DocumentName',
          documentTypeId: '$..DocumentTypeID',
          documentType: '$..DocumentType',
          file: {
            fileId: '$.DocumentID',
            fileName: '$.DocumentName'
          }
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      var rawStartDateTime = response.startDateTime;
      response.startTime = moment(rawStartDateTime, moment.ISO_8601).format('HH:mm:ss');
      response.startDate = moment(rawStartDateTime, moment.ISO_8601).format('MM/DD/YYYY');
      response.venue.fullAddress = addressToString({
        addressLine1: response.venue.streetAddress,
        addressLine2: response.venue.streetAddress2,
        city: response.venue.city,
        state: response.venue.state
      });
      response.venue.address = {
        streetAddress:
          response.venue.streetAddress + (response.venue.streetAddress2 ? ' ' + response.venue.streetAddress2 : ''),
        city: response.venue.city,
        state: response.venue.state,
        postalCode: response.venue.zipCode
      };
      response.organization.fullAddress = addressToString({
        addressLine1: response.organization.streetAddress,
        addressLine2: response.organization.streetAddress2,
        city: response.organization.city,
        state: response.organization.state
      });
      var rawEndDateTime = response.endDateTime;
      response.endTime = moment(rawEndDateTime, moment.ISO_8601).format('HH:mm:ss');
      response.endDate = moment(rawEndDateTime, moment.ISO_8601).format('MM/DD/YYYY');

      _.each(response.eventPresenters, function(presenter) {
        presenter.name = presenter.firstName + ' ' + presenter.lastName;
        presenter.eventFollowUpTaskOwner = presenter.isTaskOwner === '1' ? true : false;
      });

      if (!!response.venue.contactFirstName || !!response.venue.contactLastName) {
        response.venue.venueContactName = response.venue.contactFirstName + ' ' + response.venue.contactLastName;
      }

      response.organization.organizationContactName =
        response.organization.contactFirstName + ' ' + response.organization.contactLastName;

      defer.resolve(response);
    })
    .fail(function(err) {
      defer.reject(err);
    });

  return defer.promise();
};
